import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

const _import = require('./_import_' + process.env.NODE_ENV)
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
    { path: '/login', name: "login", component: _import('login/index'), hidden: true },
    { path: '/forget', name: "forget", component: _import('forget/index'), hidden: true },
    { path: '/register', name: 'register', component: _import('register/index'), hidden: true },
    { path: '/404', component: _import('404'), hidden: true },
    {
        path: '/account',
        component: Layout,
        redirect: '/account/index',
        name: 'accountInfo',
        hidden: true,
        meta: { role: "admin", title: '账号管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'account',
            hidden: true,
            component: _import('account/index'),
            meta: { title: '账号管理', icon: 'form', noCache: false }
        }]
    },
    // 自助建站
    // {
    //     path: '/diysite',
    //     component: Layout,
    //     redirect: '/diysite/index',
    //     name: 'diysite',
    //     meta: { title: '自助建站', icon: 'example', noCache: false },
    //     children: [{
    //         path: 'index',
    //         name: 'DiysiteIndex',
    //         hidden: false,
    //         component: _import('diysite/index'),
    //         meta: { title: '自助建站', icon: 'example', noCache: false }
    //     }, {
    //         path: 'templates',
    //         name: 'DiysiteTemplates',
    //         hidden: true,
    //         component: _import('diysite/templates'),
    //         meta: { title: '模板选择', icon: 'example', noCache: false }
    //     }, {
    //         path: 'addDiysite',
    //         name: 'AddDiysite',
    //         hidden: true,
    //         component: _import('diysite/addDiysite'),
    //         meta: { title: '网站新建', icon: 'example', noCache: false }
    //     }, {
    //         path: 'editDiysite/id/:id',
    //         name: 'EditDiysite',
    //         hidden: true,
    //         component: _import('diysite/editDiysite'),
    //         meta: { title: '网站编辑', icon: 'example', noCache: false }
    //     }]
    // },
]

export const baseRouterMap = [
    {
        path: '/',
        redirect: '/cpc/index',
    },
    {
        path: '/cpc',
        component: Layout,
        redirect: '/cpc/index',
        // name: 'order',
        meta: { role: "customer", title: 'CPC广告', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'cpc',
            hidden: false,
            component: _import('cpc/index'),
            meta: { role: "customer", title: 'CPC广告', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/position',
        component: Layout,
        hidden: true,
        meta: { role: "admin", title: 'CPC广告位', icon: 'example', noCache: true },
        children: [{
            path: ':id',
            name: 'position',
            hidden: true,
            component: _import('position/index'),
            meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
            beforeEnter: (to, from, next) => {
                if (JSON.parse(getToken()).userId === 1791) {
                    next();
                } else {
                    Message.error("没有权限进入此页面");
                    next('404')
                }
            }
        }]
    },
    {
        path: '/position/:id',
        name: 'position',
        hidden: true,
        component: _import('position/index'),
        meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
        beforeEnter: (to, from, next) => {
            if (JSON.parse(getToken()).userId === 1109) {
                console.info(8588888)
                next();
            } else {
                console.info(99999)
                Message.error("没有权限进入此页面");
                next('404')
            }
        }
    },
    {
        path: '/cpa',
        component: Layout,
        redirect: '/cpa/index',
        // name: 'order',
        meta: { role: "customer", title: 'CPA广告', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'cpa',
            hidden: false,
            component: _import('cpa/index'),
            meta: { role: "customer", title: 'CPA广告', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/adadmin',
        component: Layout,
        redirect: '/adadmin/index',
        name: 'adadmin',
        meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'adadminIndex',
            hidden: false,
            component: _import('adadmin/index'),
            meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
        },
        {
            path: 'create',
            name: 'adadminCreate',
            hidden: true,
            component: _import('adadmin/create'),
            meta: { title: '新建计划', icon: 'form', noCache: false }
        },
        {
            path: 'edit/:id',
            name: 'adadminEdit',
            hidden: true,
            component: _import('adadmin/create'),
            meta: { title: '编辑计划', icon: 'form', noCache: false }
        },
        {
            path: 'look/:id',
            name: 'adadminLook',
            hidden: true,
            component: _import('adadmin/create'),
            meta: { title: '查看计划', icon: 'form', noCache: false }
        },
        {
            path: 'adadminEditQualify/:id',
            name: 'adadminEditQualify',
            hidden: true,
            component: _import('adadmin/createQualify/index'),
            meta: { title: '编辑资质', icon: 'form', noCache: false }
        },
        {
            path: 'adadminLookQualify/:id',
            name: 'adadminLookQualify',
            hidden: true,
            component: _import('adadmin/createQualify/index'),
            meta: { title: '查看资质', icon: 'form', noCache: false }
        },
        {
            path: 'adadminCreateQualify',
            name: 'adadminCreateQualify',
            hidden: true,
            component: _import('adadmin/createQualify/index'),
            meta: { title: '新建资质', icon: 'form', noCache: false }
        },
        {
            path: 'adadminEditVideo/id/:id',
            name: 'adadminEditVideo',
            hidden: true,
            component: _import('adadmin/videoManagement/adadminCreateVideo'),
            meta: { title: '编辑视频', icon: 'form', noCache: false }
        },
        {
            path: 'adadminCreateVideo',
            name: 'adadminCreateVideo',
            hidden: true,
            component: _import('adadmin/videoManagement/adadminCreateVideo'),
            meta: { title: '新建视频', icon: 'form', noCache: false }
        },
        {
            path: 'qualifyManagement',
            name: 'adadminQualifyManagement',
            hidden: false,
            component: _import('adadmin/qualifyManagement/index'),
            meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
        },
        {
            path: 'videoManagement',
            name: 'videoManagement',
            hidden: false,
            component: _import('adadmin/videoManagement/index'),
            meta: { role: "customer", title: '视频管理', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/arrears',
        component: Layout,
        redirect: '/arrears/index',
        name: 'arrears',
        hidden: true,
        meta: { role: "admin", title: '欠款明细', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'arrearsIndex',
            hidden: true,
            component: _import('arrears/index'),
            meta: { title: '欠款明细', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/user/notice',
        component: Layout,
        redirect: '/user/notice/index',
        name: 'notice',
        meta: { title: '消息中心', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'noticeIndex',
            component: _import('notice/index'),
            meta: { title: '消息中心', icon: 'form', noCache: false }
        }]
    },
]

export const customerRouterMap = [
    {
        path: '/subfinance',
        component: Layout,
        redirect: '/subfinance/index',
        // name: 'order',
        // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'subfinance',
            hidden: true,
            component: _import('subfinance/index'),
            meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/sublogs',
        component: Layout,
        redirect: '/sublogs/index',
        // name: 'order',
        // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'sublogs',
            hidden: true,
            component: _import('sublogs/index'),
            meta: { role: "customer", title: '券操作日志', icon: 'form', noCache: false }
        }]
    },
    { path: '*', redirect: '/404', hidden: true }
]

export const adminRouterMap = [
    {
        path: '/finance',
        component: Layout,
        redirect: '/finance/index',
        // name: 'order',
        // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'finance',
            hidden: true,
            component: _import('finance/index'),
            meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/subaccount',
        component: Layout,
        redirect: '/subaccount/index',
        // name: 'order',
        // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'subaccount',
            hidden: true,
            component: _import('subaccount/index'),
            meta: { role: "customer", title: '子账号管理', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/logs',
        component: Layout,
        redirect: '/logs/index',
        // name: 'order',
        // meta: { role: "customer", title: '订单管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'logs',
            hidden: true,
            component: _import('logs/index'),
            meta: { role: "customer", title: '券操作日志', icon: 'form', noCache: false }
        }]
    },
    { path: '*', redirect: '/404', hidden: true }
]

// 绑定账户的广告主
export const bindAccountRouterMap = [
    {
        path: '/',
        redirect: '/placeData/index',
    },
    {
        path: '/placeData',
        component: Layout,
        redirect: '/placeData/index',
        children: [{
            path: 'index',
            name: 'placeData',
            hidden: true,
            component: _import('placeData/index'),
            meta: { role: "customer", title: '投放数据', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/adadmin',
        component: Layout,
        redirect: '/adadmin/qualifyManagement',
        name: 'adadmin',
        meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
        children: [
            {
                path: 'qualifyManagement',
                name: 'adadminQualifyManagement',
                hidden: false,
                component: _import('adadmin/qualifyManagement/index'),
                meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
            },{
            path: 'adadminEditQualify/:id',
            name: 'adadminEditQualify',
            hidden: true,
            component: _import('adadmin/createQualify/index'),
            meta: { title: '编辑资质', icon: 'form', noCache: false }
        },
        {
            path: 'adadminLookQualify/:id',
            name: 'adadminLookQualify',
            hidden: true,
            component: _import('adadmin/createQualify/index'),
            meta: { title: '查看资质', icon: 'form', noCache: false }
        },
        {
            path: 'adadminCreateQualify',
            name: 'adadminCreateQualify',
            hidden: true,
            component: _import('adadmin/createQualify/index'),
            meta: { title: '新建资质', icon: 'form', noCache: false }
        },]
    },
]

// 海外admin
export const adminAbroadRouterMap = [
    {
        path: '/',
        redirect: '/finance/index',
    },
    {
        path: '/adadmin',
        component: Layout,
        redirect: '/adadmin/qualifyManagement',
        name: 'adadmin',
        meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
        children: [
            {
                path: 'qualifyManagement',
                name: 'adadminQualifyManagement',
                hidden: false,
                component: _import('adadmin/qualifyManagement/index'),
                meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
            },
            {
                path: 'index',
                name: 'adadminIndex',
                hidden: false,
                component: _import('adadmin/index'),
                meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
            },
            {
                path: 'create',
                name: 'adadminCreate',
                hidden: true,
                component: _import('adadmin/create'),
                meta: { title: '新建计划', icon: 'form', noCache: false }
            },
            {
                path: 'edit/:id',
                name: 'adadminEdit',
                hidden: true,
                component: _import('adadmin/create'),
                meta: { title: '编辑计划', icon: 'form', noCache: false }
            },
            {
                path: 'look/:id',
                name: 'adadminLook',
                hidden: true,
                component: _import('adadmin/create'),
                meta: { title: '查看计划', icon: 'form', noCache: false }
            },
            {
                path: 'adadminEditQualify/:id',
                name: 'adadminEditQualify',
                hidden: true,
                component: _import('adadmin/createQualify/index'),
                meta: { title: '编辑资质', icon: 'form', noCache: false }
            },
            {
                path: 'adadminLookQualify/:id',
                name: 'adadminLookQualify',
                hidden: true,
                component: _import('adadmin/createQualify/index'),
                meta: { title: '查看资质', icon: 'form', noCache: false }
            },
            {
                path: 'adadminCreateQualify',
                name: 'adadminCreateQualify',
                hidden: true,
                component: _import('adadmin/createQualify/index'),
                meta: { title: '新建资质', icon: 'form', noCache: false }
            },
            {
                path: 'adadminEditVideo/id/:id',
                name: 'adadminEditVideo',
                hidden: true,
                component: _import('adadmin/videoManagement/adadminCreateVideo'),
                meta: { title: '编辑视频', icon: 'form', noCache: false }
            },
            {
                path: 'adadminCreateVideo',
                name: 'adadminCreateVideo',
                hidden: true,
                component: _import('adadmin/videoManagement/adadminCreateVideo'),
                meta: { title: '新建视频', icon: 'form', noCache: false }
            }]
    },
    {
        path: '/finance',
        component: Layout,
        redirect: '/finance/index',
        children: [{
            path: 'index',
            name: 'finance',
            hidden: true,
            component: _import('finance/index'),
            meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/subaccount',
        component: Layout,
        redirect: '/subaccount/index',
        children: [{
            path: 'index',
            name: 'subaccount',
            hidden: true,
            component: _import('subaccount/index'),
            meta: { role: "customer", title: '子账号管理', icon: 'form', noCache: false }
        }]
    },
    { path: '*', redirect: '/404', hidden: true }
]
// 海外子账号
export const customerAbroadRouterMap = [
    {
        path: '/',
        redirect: '/cpc/index',
    },
    {
        path: '/adadmin',
        component: Layout,
        redirect: '/adadmin/qualifyManagement',
        name: 'adadmin',
        meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
        children: [
            {
                path: 'qualifyManagement',
                name: 'adadminQualifyManagement',
                hidden: false,
                component: _import('adadmin/qualifyManagement/index'),
                meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
            },
            {
                path: 'index',
                name: 'adadminIndex',
                hidden: false,
                component: _import('adadmin/index'),
                meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
            },
            {
                path: 'create',
                name: 'adadminCreate',
                hidden: true,
                component: _import('adadmin/create'),
                meta: { title: '新建计划', icon: 'form', noCache: false }
            },
            {
                path: 'edit/:id',
                name: 'adadminEdit',
                hidden: true,
                component: _import('adadmin/create'),
                meta: { title: '编辑计划', icon: 'form', noCache: false }
            },
            {
                path: 'look/:id',
                name: 'adadminLook',
                hidden: true,
                component: _import('adadmin/create'),
                meta: { title: '查看计划', icon: 'form', noCache: false }
            },
            {
                path: 'adadminEditQualify/:id',
                name: 'adadminEditQualify',
                hidden: true,
                component: _import('adadmin/createQualify/index'),
                meta: { title: '编辑资质', icon: 'form', noCache: false }
            },
            {
                path: 'adadminLookQualify/:id',
                name: 'adadminLookQualify',
                hidden: true,
                component: _import('adadmin/createQualify/index'),
                meta: { title: '查看资质', icon: 'form', noCache: false }
            },
            {
                path: 'adadminCreateQualify',
                name: 'adadminCreateQualify',
                hidden: true,
                component: _import('adadmin/createQualify/index'),
                meta: { title: '新建资质', icon: 'form', noCache: false }
            },
            {
                path: 'adadminEditVideo/id/:id',
                name: 'adadminEditVideo',
                hidden: true,
                component: _import('adadmin/videoManagement/adadminCreateVideo'),
                meta: { title: '编辑视频', icon: 'form', noCache: false }
            },
            {
                path: 'adadminCreateVideo',
                name: 'adadminCreateVideo',
                hidden: true,
                component: _import('adadmin/videoManagement/adadminCreateVideo'),
                meta: { title: '新建视频', icon: 'form', noCache: false }
            }]
    },
    // {
    //     path: '/finance',
    //     component: Layout,
    //     redirect: '/finance/index',
    //     children: [{
    //         path: 'index',
    //         name: 'finance',
    //         hidden: true,
    //         component: _import('finance/index'),
    //         meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
    //     }]
    // },
    { path: '*', redirect: '/404', hidden: true }
]
// 海外路由
export const abroadRouterMap = [
    { path: '/login', name: "login", component: _import('login/index'), hidden: true },
    { path: '/forget', name: "forget", component: _import('forget/index'), hidden: true },
    { path: '/register', name: 'register', component: _import('register/index'), hidden: true },
    { path: '/404', component: _import('404'), hidden: true },
    // {
    //     path: '/',
    //     redirect: '/cpc/index',
    // },
    {
        path: '/cpc',
        component: Layout,
        redirect: '/cpc/index',
        // name: 'order',
        meta: { role: "customer", title: 'CPC广告', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'cpc',
            hidden: false,
            component: _import('cpc/index'),
            meta: { role: "customer", title: 'CPC广告', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/position',
        component: Layout,
        hidden: true,
        meta: { role: "admin", title: 'CPC广告位', icon: 'example', noCache: true },
        children: [{
            path: ':id',
            name: 'position',
            hidden: true,
            component: _import('position/index'),
            meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
            beforeEnter: (to, from, next) => {
                if (JSON.parse(getToken()).userId === 1791) {
                    next();
                } else {
                    Message.error("没有权限进入此页面");
                    next('404')
                }
            }
        }]
    },
    {
        path: '/position/:id',
        name: 'position',
        hidden: true,
        component: _import('position/index'),
        meta: { role: "customer", title: 'CPC广告位', icon: 'form', noCache: false },
        beforeEnter: (to, from, next) => {
            if (JSON.parse(getToken()).userId === 1109) {
                console.info(8588888)
                next();
            } else {
                console.info(99999)
                Message.error("没有权限进入此页面");
                next('404')
            }
        }
    },
    {
        path: '/cpa',
        component: Layout,
        redirect: '/cpa/index',
        // name: 'order',
        meta: { role: "customer", title: 'CPA广告', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'cpa',
            hidden: false,
            component: _import('cpa/index'),
            meta: { role: "customer", title: 'CPA广告', icon: 'form', noCache: false }
        }]
    },
    // {
    //     path: '/adadmin',
    //     component: Layout,
    //     redirect: '/adadmin/qualifyManagement',
    //     name: 'adadmin',
    //     meta: { role: "customer", title: '广告管理', icon: 'example', noCache: true },
    //     children: [
    //     {
    //         path: 'qualifyManagement',
    //         name: 'adadminQualifyManagement',
    //         hidden: false,
    //         component: _import('adadmin/qualifyManagement/index'),
    //         meta: { role: "customer", title: '资质管理', icon: 'form', noCache: false }
    //     },
    //     // {
    //     //     path: 'index',
    //     //     name: 'adadminIndex',
    //     //     hidden: false,
    //     //     component: _import('adadmin/index'),
    //     //     meta: { role: "customer", title: '广告管理', icon: 'form', noCache: false }
    //     // },
    //     {
    //         path: 'create',
    //         name: 'adadminCreate',
    //         hidden: true,
    //         component: _import('adadmin/create'),
    //         meta: { title: '新建计划', icon: 'form', noCache: false }
    //     },
    //     {
    //         path: 'edit/:id',
    //         name: 'adadminEdit',
    //         hidden: true,
    //         component: _import('adadmin/create'),
    //         meta: { title: '编辑计划', icon: 'form', noCache: false }
    //     },
    //     {
    //         path: 'look/:id',
    //         name: 'adadminLook',
    //         hidden: true,
    //         component: _import('adadmin/create'),
    //         meta: { title: '查看计划', icon: 'form', noCache: false }
    //     },
    //     {
    //         path: 'adadminEditQualify/:id',
    //         name: 'adadminEditQualify',
    //         hidden: true,
    //         component: _import('adadmin/createQualify/index'),
    //         meta: { title: '编辑资质', icon: 'form', noCache: false }
    //     },
    //     {
    //         path: 'adadminLookQualify/:id',
    //         name: 'adadminLookQualify',
    //         hidden: true,
    //         component: _import('adadmin/createQualify/index'),
    //         meta: { title: '查看资质', icon: 'form', noCache: false }
    //     },
    //     {
    //         path: 'adadminCreateQualify',
    //         name: 'adadminCreateQualify',
    //         hidden: true,
    //         component: _import('adadmin/createQualify/index'),
    //         meta: { title: '新建资质', icon: 'form', noCache: false }
    //     },
    //     {
    //         path: 'adadminEditVideo/id/:id',
    //         name: 'adadminEditVideo',
    //         hidden: true,
    //         component: _import('adadmin/videoManagement/adadminCreateVideo'),
    //         meta: { title: '编辑视频', icon: 'form', noCache: false }
    //     },
    //     {
    //         path: 'adadminCreateVideo',
    //         name: 'adadminCreateVideo',
    //         hidden: true,
    //         component: _import('adadmin/videoManagement/adadminCreateVideo'),
    //         meta: { title: '新建视频', icon: 'form', noCache: false }
    //     }]
    // },
    // {
    //     path: '/finance',
    //     component: Layout,
    //     redirect: '/finance/index',
    //     children: [{
    //         path: 'index',
    //         name: 'finance',
    //         hidden: true,
    //         component: _import('finance/index'),
    //         meta: { role: "customer", title: '账务数据', icon: 'form', noCache: false }
    //     }]
    // },
    {
        path: '/arrears',
        component: Layout,
        redirect: '/arrears/index',
        name: 'arrears',
        hidden: true,
        meta: { role: "admin", title: '欠款明细', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'arrearsIndex',
            hidden: true,
            component: _import('arrears/index'),
            meta: { title: '欠款明细', icon: 'form', noCache: false }
        }]
    },
    {
        path: '/account',
        component: Layout,
        redirect: '/account/index',
        name: 'accountInfo',
        hidden: true,
        meta: { role: "admin", title: '账号管理', icon: 'example', noCache: true },
        children: [{
            path: 'index',
            name: 'account',
            hidden: true,
            component: _import('account/index'),
            meta: { title: '账号管理', icon: 'form', noCache: false }
        }]
    },
    // {
    //     path: '/subaccount',
    //     component: Layout,
    //     redirect: '/subaccount/index',
    //     children: [{
    //         path: 'index',
    //         name: 'subaccount',
    //         hidden: true,
    //         component: _import('subaccount/index'),
    //         meta: { role: "customer", title: '子账号管理', icon: 'form', noCache: false }
    //     }]
    // },
]

export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    // 判断是否海外}
    routes: localStorage.getItem('areaType') == 1 ? abroadRouterMap : constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js